module.exports = __webpack_public_path__ + "img/9788959522798.13ef9e5e.jpg";